module.exports = __webpack_public_path__ + "static/media/app-screen-01.4efa97d3.jpg";